import { discountAmount, type QuoteDiscount } from "@rutamagica/contracts";
import { Field, SelectField } from "../../components/ui";
import { money } from "./shared";

/** Optional seller discount: none, a percentage (e.g. 10%) or an amount in pesos (e.g. $200). */
export function DiscountFields({ discount, subtotal, currency, onChange }: {
  discount: QuoteDiscount | null;
  subtotal: number;
  currency: string;
  onChange: (discount: QuoteDiscount | null) => void;
}) {
  const type = discount?.type ?? "none";
  const off = discountAmount(discount, subtotal);
  return (
    <section className="quote-discount" aria-label="Descuento">
      <h3>Descuento</h3>
      <div className="quote-form-grid quote-form-grid--dense">
        <SelectField
          className="span-8"
          label="Tipo de descuento"
          value={type}
          onChange={(e) => {
            const next = e.target.value;
            onChange(next === "none" ? null : { type: next as QuoteDiscount["type"], value: discount?.value ?? 0 });
          }}
        >
          <option value="none">Sin descuento</option>
          <option value="percent">Porcentaje (%)</option>
          <option value="amount">Monto en pesos ($)</option>
        </SelectField>
        {discount && (
          <Field
            className="span-6"
            label={discount.type === "percent" ? "Porcentaje" : "Monto"}
            type="number"
            min={0}
            max={discount.type === "percent" ? 99 : undefined}
            step="any"
            value={discount.value ? String(discount.value) : ""}
            onChange={(e) => onChange({ ...discount, value: Number(e.target.value) || 0 })}
          />
        )}
        {discount && subtotal > 0 && (
          <p className="quote-discount__summary span-10" role="status">
            <span>Subtotal {money(subtotal, currency)}</span>
            <span>− {money(off, currency)}</span>
            <strong>Total {money(subtotal - off, currency)}</strong>
          </p>
        )}
      </div>
    </section>
  );
}
